import VideoPlayer from '@rentspree/component-v2/dist/video-player'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import styled from 'styled-components'

import { useModal, useTracker } from '@hooks'
import { Icon } from 'components'
import { ListingIdContext } from 'context/listingIdContext'
import { useSelector } from 'store'
import { selectPublicListing } from 'store/public-listing'
import { COLOR } from 'styles/constants'
import { LISTING_PUBLIC_PAGE } from 'tracker/events'

import { CTAButton } from '../styled'

const VideoPlayerModal = styled.div`
  width: 70vw;
  min-width: 920px;
  height: auto;

  @media only screen and (max-width: 991px) {
    width: 100vw;
    min-width: auto;
  }

  .button-close {
    position: fixed;
    top: 0;
    right: 0;
    padding: 0.5em 1em;
    font-size: 1.5em;
    color: ${COLOR.WHITE};
    background-color: transparent;
    border: none;
  }
`
interface ListingVideoProps {
  isPreview?: boolean
}
export const ListingVideo: React.FC<ListingVideoProps> = ({ isPreview = false }) => {
  const { video = undefined } = useSelector(selectPublicListing)
  const track = useTracker()
  const modalOptions = {
    preventScroll: true,
    closeOnOverlayClick: true,
    customStyled: {},
  }
  const listingId = useContext(ListingIdContext)

  const [Modal, openModal, closeModal] = useModal('__next', modalOptions)

  const onStart = () => {
    track(LISTING_PUBLIC_PAGE.CLICK_WATCH_VIDEO_TOUR, { listing_id: listingId })
  }

  const onEnded = () => {
    track(LISTING_PUBLIC_PAGE.WATCH_FULL_VIDEO_TOUR, { listing_id: listingId })
  }
  if (!video) return null
  return (
    <>
      <CTAButton
        id="video-modal-trigger"
        disabled={isPreview}
        onClick={
          isPreview
            ? () => {
                // do nothing
              }
            : () => {
                onStart()
                openModal()
              }
        }
      >
        Watch Video Tour
      </CTAButton>
      <Modal>
        <VideoPlayerModal data-testid="video-modal">
          <VideoPlayer src={video} onEnded={onEnded} />
          <button type="button" onClick={closeModal} className="button-close">
            <Icon name="close" size="md" />
          </button>
        </VideoPlayerModal>
      </Modal>
    </>
  )
}

ListingVideo.defaultProps = {
  isPreview: false,
}

ListingVideo.propTypes = {
  isPreview: PropTypes.bool,
}
